import { render, staticRenderFns } from "./Cyberbiz.vue?vue&type=template&id=3138c39d&"
import script from "./Cyberbiz.vue?vue&type=script&lang=js&"
export * from "./Cyberbiz.vue?vue&type=script&lang=js&"
import style0 from "./Cyberbiz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports